export default `

  query getWines( $limit: Int!, $latest: Boolean!, $featured: Boolean! ) {
    wines (limit: $limit, latest: $latest, featured: $featured, allowincart: true) {
      ... on ContentInterface {
        title
        path
      }
      ... on ProductInterface {
        abstract
        images {
          image {
            filepath
            filesize
            filemime
            preset
            filestorename
          }
        }
        productsettings {
          price
        }
      }
      ... on WineProduct {
        award_winner
      }
    }
  }

  query getNews ( $limit: Int!, $latest: Boolean!, $featured: Boolean!, $category: NewsCategory! ) {
    newslist (limit: $limit, latest: $latest, featured: $featured, category: $category) {
      title
      modified
      created
      abstract
      assets {
        thumbnail {
          filepath
          filesize
          filemime
          preset
          filestorename
          data {
            alt
            title
          }
        }
      }
      seo {
        path
      }
    }
  }

  query getProducts ( $limit: Int!, $latest: Boolean!, $featured: Boolean! ) {
    products (limit: $limit, latest: $latest, featured: $featured, allowincart: true) {
      ... on ContentInterface {
        title
        path
      }
      ... on ProductInterface {
        abstract
        images {
          image {
            filepath
            filesize
            filemime
            preset
            filestorename
          }
        }
        productsettings {
          price
        }
      }
    }
  }
`
